<template>
  <vx-card title="ตรวจสอบคิวอาร์โค้ด">
    <p class="mb-4">QR ทุกประเภทที่ยังไม่ชำระใน 7 วันล่าสุด รวมวันนี้ {{ day || '—' }} (เวลาไทย) · {{ total }} รายการ</p>
    <form class="qr-filters mb-4" @submit.prevent="search">
      <label>ชื่อสัญญา<input v-model="filters.contractName" maxlength="120" :disabled="loading || busy" placeholder="ค้นหาบางส่วนของชื่อสัญญา"></label>
      <label>เลขที่สัญญา<input v-model="filters.contractNo" maxlength="120" :disabled="loading || busy" placeholder="ค้นหาบางส่วนของเลขที่สัญญา"></label>
      <button type="submit" :disabled="loading || busy">ค้นหา</button>
      <button type="button" :disabled="loading || busy" @click="clearFilters">ล้างตัวกรอง</button>
    </form>
    <p v-if="!testEnabled && !loading" class="mb-4">ปุ่มทดสอบปิดอยู่ กรุณาตรวจ config dev และสิทธิ์แก้ไขของผู้ดูแลระบบ</p>
    <p v-if="error" role="alert" class="text-danger mb-4">{{ error }}</p>
    <div class="qr-table-wrap">
      <table class="qr-table">
        <thead><tr><th>สร้างเมื่อ (เวลาไทย)</th><th>ชื่อสัญญา</th><th>สัญญา / Ref 1</th><th>Ref 2</th><th>ประเภท</th><th>ยอด (บาท)</th><th>ดำเนินการ</th></tr></thead>
        <tbody>
          <tr v-for="qr in items" :key="qr.id">
            <td>{{ dateTime(qr.createdAt) }}</td><td>{{ qr.loan && qr.loan.contract ? (qr.loan.contract.contractName || '—') : '—' }}</td><td>{{ qr.ref1 }}</td><td>{{ qr.ref2 }}</td><td>{{ qrTypeName(qr.type) }}</td><td>{{ money(qr.amount) }}</td>
            <td class="qr-actions">
              <vs-button size="small" :disabled="busy || loading" @click="showQr(qr)">แสดง QR</vs-button>
              <vs-button v-if="isRoot" size="small" color="danger" type="border" :disabled="busy || loading || mustRefresh" @click="askCancel(qr)">ยกเลิก QR</vs-button>
              <vs-button v-for="action in actions" :key="action.value" size="small" type="border"
                :disabled="!testEnabled || busy || loading || mustRefresh || unsupported(qr)" @click="ask(qr, action.value)">{{ action.label }}</vs-button>
            </td>
          </tr>
          <tr v-if="!items.length"><td colspan="7">{{ loading ? 'กำลังโหลด…' : 'ไม่พบ QR Code ที่ยังไม่ชำระใน 7 วันล่าสุด' }}</td></tr>
        </tbody>
      </table>
    </div>
    <div class="qr-pagination mt-4">
      <vs-button size="small" :disabled="page <= 1 || loading || busy" @click="refresh(page - 1)">ก่อนหน้า</vs-button>
      <span>หน้า {{ page }} / {{ Math.max(1, Math.ceil(total / pageSize)) }}</span>
      <vs-button size="small" :disabled="page * pageSize >= total || loading || busy" @click="refresh(page + 1)">ถัดไป</vs-button>
    </div>
    <vs-popup :title="actionError ? 'ยังยืนยันผลไม่ได้' : 'ผลการดำเนินการ'" :active.sync="resultOpen">
      <p v-if="actionError" role="alert" class="text-danger mb-4">{{ actionError }}</p>
      <div v-if="result && !actionError" role="status" class="qr-action-result"
           :class="result.responseCode === '000' ? 'qr-action-success' : 'qr-action-warning'">
        <p><strong>{{ result.action }} · {{ result.responseCode }}: {{ result.responseMesg }}</strong></p>
        <p>Request: {{ result.requestRef }}</p>
        <p v-if="result.warning">{{ result.warning }}</p>
        <p v-if="result.action === 'NOTIFY'">ตรวจสอบรายการรับชำระในสัญญาเพื่อยืนยันผลการประมวลผลด้วย</p>
      </div>
      <vs-button class="mt-4" @click="resultOpen = false">ตกลง</vs-button>
    </vs-popup>
    <QrPaymentModal :active.sync="qrOpen" :qr="selected" />
    <vs-popup :title="pending && pending.action === 'CANCEL' ? 'ยืนยันยกเลิก QR Code' : 'ยืนยันการทดสอบ dev'" :active.sync="confirmOpen">
      <div v-if="pending">
        <p>{{ pending.action }} · สัญญา {{ pending.qr.ref1 }} · {{ money(pending.qr.amount) }} บาท</p>
        <p class="my-4">{{ actionDescription(pending.action) }}</p>
        <vs-button :disabled="busy || mustRefresh" @click="send()">{{ busy ? 'กำลังส่ง…' : 'ยืนยันส่งคำสั่ง' }}</vs-button>
        <vs-button type="border" class="ml-2" :disabled="busy" @click="confirmOpen = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>
<script>
import { gql } from 'apollo-boost'
import { apolloClient } from '@/setup/apollo-setup'
import QrPaymentModal from '@/components/QrPaymentModal.vue'
const LIST = gql`query TodayUnpaidQrPayments($page: Int, $contractNo: String, $contractName: String) {
  getTodayUnpaidQrPayments(page: $page, contractNo: $contractNo, contractName: $contractName) {
    day total page pageSize testEnabled
    items {
      loan { contract { contractName } }
      id type taxId suffix ref1 ref2 amount createdAt
      paidFee paidPenalty paidInterest paidPrinciple balanceRemain
      paidContractFee paidTaxAmount paidProcessingFee paidCourtOrderExpense
      dueDate(local: true, format: "DD MMM YYYY HH:mm น.")
    }
  }
}`
const TEST = gql`mutation TestDevQrPayment($qrPaymentId: ID!, $action: DevQrAction!) {
  testDevQrPayment(qrPaymentId: $qrPaymentId, action: $action) { action requestRef responseCode responseMesg warning }
}`
const CANCEL = gql`mutation CancelUnpaidQrPayment($qrPaymentId: ID!) {
  cancelUnpaidQrPayment(qrPaymentId: $qrPaymentId)
}`
export default {
  components: { QrPaymentModal },
  data () { return {
    filters: { contractNo: '', contractName: '' }, appliedFilters: { contractNo: '', contractName: '' },
    items: [], total: 0, page: 1, pageSize: 25, day: '', testEnabled: false, loading: false, busy: false,
    error: '', actionError: '', resultOpen: false, result: null, mustRefresh: false, selected: null, qrOpen: false, confirmOpen: false, pending: null,
    actions: [{ value: 'VERIFY', label: 'Verify' }, { value: 'NOTIFY', label: 'Noti' }, { value: 'REVERSE', label: 'Revert' }]
  } },
  created () {
    if (this.isRoot || this.pms('SystemAdministrator', 'visible', 'r')) this.refresh()
  },
  methods: {
    search () {
      if (this.loading || this.busy) return
      this.appliedFilters = { contractNo: this.filters.contractNo.trim(), contractName: this.filters.contractName.trim() }
      return this.refresh(1)
    },
    clearFilters () {
      if (this.loading || this.busy) return
      this.filters = { contractNo: '', contractName: '' }
      return this.search()
    },
    actionErrorMessage (error) {
      const messages = error && Array.isArray(error.graphQLErrors)
        ? error.graphQLErrors.map(item => item.message).filter(Boolean) : []
      const message = [...new Set(messages)].join(' / ') || (error && error.message) || 'ยังยืนยันผลจาก noti server ไม่ได้'
      const clean = message.replace(/^(GraphQL error:\s*)+/i, '')
      return clean.includes('ตรวจรายการรับชำระ') ? clean : clean + ' — รีเฟรชหน้าเว็บและตรวจรายการรับชำระก่อนส่งซ้ำ'
    },
    qrTypeName (type) {
      const names = {
        extra: 'ชำระเพิ่มเติม', normal: 'ยอดปัจจุบัน', custom: 'กำหนดยอดเอง',
        close: 'ยอดปิดบัญชี', outstanding: 'ยอดค้างชำระ',
        contractFee: 'ค่าธรรมเนียมการทำสัญญา', registrationFeeExtra: 'ค่าลงทะเบียน',
        taxAmount: 'ค่าอากรแสตมป์', processingFee: 'ค่าดำเนินการ',
        courtOrderExpense: 'ค่าใช้จ่ายอื่นตามคำสั่งศาล', allExpenses: 'ค่าใช้จ่ายทั้งหมด'
      }
      return Object.prototype.hasOwnProperty.call(names, type) ? names[type] : (type || 'ไม่ระบุประเภท')
    },
    money (value) { return Number(value).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    dateTime (value) { return new Date(value).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok', hour12: false }) },
    unsupported (qr) { return ['extra', 'registrationFeeExtra'].includes(qr.type) },
    async refresh (page = this.page) {
      if (this.loading) return
      this.loading = true
      this.error = ''
      this.testEnabled = false
      try {
        const { data } = await apolloClient.query({ query: LIST, variables: { page, ...this.appliedFilters }, fetchPolicy: 'network-only' })
        Object.assign(this, data.getTodayUnpaidQrPayments)
        this.mustRefresh = false
        this.pending = null
        this.confirmOpen = false
      } catch (error) {
        this.error = error.message || 'โหลดข้อมูลไม่สำเร็จ'
        this.mustRefresh = true
      } finally { this.loading = false }
    },
    showQr (qr) {
      this.selected = { ...qr }
      this.qrOpen = true
    },
    actionDescription (action) {
      if (action === 'CANCEL') return 'ยกเลิก QR ที่ยังไม่รับชำระเท่านั้น QR นี้จะใช้ชำระไม่ได้อีก เก็บประวัติไว้และไม่ใช่การคืนเงินผ่านธนาคาร'
      return action === 'NOTIFY' ? 'จำลองรับเงิน: จะบันทึกการชำระและประมวลผลยอดในฐานข้อมูล dev จริง' :
        action === 'REVERSE' ? 'เรียก reverse: ปัจจุบัน noti server ตอบรับเท่านั้น ยังไม่มีการย้อนรายการชำระ' :
          'ตรวจสอบข้อมูล QR ผ่าน noti server และบันทึก verify log ใน dev'
    },
    ask (qr, action) {
      if (!this.testEnabled || this.busy || this.loading || this.mustRefresh || this.unsupported(qr)) return
      this.pending = { qr, action }
      this.confirmOpen = true
    },
    askCancel (qr) {
      if (!this.isRoot || this.busy || this.loading || this.mustRefresh) return
      this.pending = { qr, action: 'CANCEL' }
      this.confirmOpen = true
    },
    async send () {
      if (!this.pending || this.busy || this.loading || this.mustRefresh) return
      if (this.pending.action === 'CANCEL' ? !this.isRoot : !this.testEnabled) return
      this.busy = true
      this.error = ''
      this.result = null
      this.actionError = ''
      this.resultOpen = false
      const pending = this.pending
      try {
        if (pending.action === 'CANCEL') {
          await apolloClient.mutate({ mutation: CANCEL, variables: { qrPaymentId: pending.qr.id } })
          this.result = { action: 'ยกเลิก QR', responseCode: '000', responseMesg: 'ยกเลิก QR Code เรียบร้อยแล้ว', requestRef: pending.qr.ref2 }
        } else {
          const { data } = await apolloClient.mutate({ mutation: TEST, variables: { qrPaymentId: pending.qr.id, action: pending.action } })
          this.result = data.testDevQrPayment
        }
        this.confirmOpen = false
        this.qrOpen = false
        await this.refresh()
        this.resultOpen = true
      } catch (error) {
        this.actionError = this.actionErrorMessage(error)
        this.resultOpen = true
        this.mustRefresh = true
        this.confirmOpen = false
      } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.qr-action-result { padding: 16px; border-radius: 6px; line-height: 1.7; overflow-wrap: anywhere; }
.qr-action-success { background: #eaf7ef; color: #176534; }
.qr-action-warning { background: #fff4df; color: #805600; }
.qr-table-wrap { overflow-x: auto; }
.qr-table { width: 100%; border-collapse: collapse; }
.qr-table th, .qr-table td { padding: 12px; border-bottom: 1px solid #ddd; text-align: left; white-space: nowrap; }
.qr-actions > * { margin: 3px; }
.qr-pagination { display: flex; gap: 16px; align-items: center; }
.qr-filters { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px; }
.qr-filters label { flex: 1 1 220px; }
.qr-filters input { display: block; width: 100%; padding: 9px 12px; margin-top: 5px; border: 1px solid #d5dce3; border-radius: 5px; }
.qr-filters button { padding: 9px 16px; border: 1px solid #174e78; border-radius: 5px; color: #174e78; background: white; cursor: pointer; }
.qr-filters button[type="submit"] { background: #174e78; color: white; }
.qr-filters button:disabled { opacity: .5; cursor: default; }
</style>
